import { InjectionToken } from '@angular/core';
import { IErrorDialogService } from '../../dialogs/error/_interfaces/error-dialog-service.interface';

export const ErrorDialogServiceInjectionToken = new InjectionToken<
  IErrorDialogService
>('ErrorDialogService');
